import { useEffect, useState } from 'react';
import { Camera, LocateFixed, Clock, AlertTriangle, Wifi, WifiOff } from 'lucide-react';
import { toFa } from '../../utils/faFormat';
import { distanceToSite } from '../../hooks/useGeoFix';

export default function CaptureStatusStrip({ capture, geo, site, offset = 0 }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const timer = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(timer); }, []);
  const distance = distanceToSite(geo.fix, site);
  const far = distance != null && capture.max_distance_m != null && distance > capture.max_distance_m;
  const inaccurate = geo.fix && geo.fix.accuracy_m > capture.gps_max_accuracy_m;
  const offlineAllowed = capture.offline_capture !== false;
  // The static policy line sits above the sticky strip so the strip stays short on small phones.
  return <>
    <p className="inst-capture-policy">{offlineAllowed
      ? <><WifiOff size={18} aria-hidden="true" />بدون اینترنت هم می‌توانید عکس بگیرید؛ این عکس‌ها را ناظر بررسی می‌کند.</>
      : <><Wifi size={18} aria-hidden="true" />برای این مرحله اینترنت لازم است.</>}</p>
    <div className="inst-capture-strip">
      <div role="status" className="inst-capture-indicators">
        <span><Camera size={18} aria-hidden="true" />فقط دوربین برنامه</span>
        <span className={far || inaccurate ? 'is-warning' : geo.status === 'denied' ? 'is-error' : ''}>
          <LocateFixed size={18} aria-hidden="true" />
          {geo.fix ? `دقت ${toFa(Math.round(geo.fix.accuracy_m))} متر${distance == null ? '' : ` · ${toFa(Math.round(distance))} متر تا محل مشتری`}`
            : geo.status === 'denied' ? 'اجازهٔ موقعیت مکانی خاموش است.' : geo.status === 'searching' ? 'در حال یافتن موقعیت…' : 'موقعیت پیدا نشد؛ اگر در فضای بسته هستید، نزدیک در یا پنجره بروید.'}
        </span>
      </div>
      <span className="inst-capture-time"><Clock size={18} aria-hidden="true" />ساعت {new Date(now).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}</span>
      {(far || inaccurate || Math.abs(offset) > 300000) && <div role="status" className="inst-stage-warning">
        <AlertTriangle size={18} aria-hidden="true" />
        <div>
          {far && <p>{toFa(Math.round(distance))} متر از محل ثبت‌شدهٔ مشتری فاصله دارید؛ {capture.review_mode === 'ai_only' ? 'این مورد بررسی می‌شود.' : 'ناظر این را می‌بیند.'}</p>}
          {inaccurate && <p>دقت موقعیت پایین است؛ نزدیک در یا پنجره بروید.</p>}
          {Math.abs(offset) > 300000 && <p>ساعت گوشی {toFa(Math.round(Math.abs(offset) / 60000))} دقیقه با سامانه فرق دارد؛ آن را روی «خودکار» بگذارید.</p>}
        </div>
      </div>}
    </div>
  </>;
}
